<template>
	<div style="box-sizing: border-box;padding: 10px;min-height: 100%;" v-loading="loading">
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="settlementtasklist"
			collapse @item-click="itemClick" v-if="settlementtasklist.length!=0"></v-jstree>
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				settlementtasklist: [],
				settlementtasksource: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				currentChildren: [],
			}
		},
		created() {
			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.settlementtasklist = []
				this.$api.supplier.listSettlementTask({
					currentPage: -1
				}).then((res) => {
					let year = []
					let list = JSON.parse(JSON.stringify(res))
					list.forEach((item) => {
						item.year = this.timestampToYear(item.begin_time * 1000)
						item.parentid = item.year
						let hasyear = year.find((yitem) => {
							return yitem.id == item.year
						})
						if (!hasyear) {
							year.push({
								id: item.year,
								name: item.year,
								parentid:0,
								childrenid:[item.id]
							})
						}else{
							hasyear.childrenid.push(item.id)
						}
					})
					list = list.concat(year)
					let root = []
					list.forEach((item) => {
						if (item.parentid == 0) {
							root.push(item)
						} else {
							list.forEach((_item) => {
								if (item.parentid == _item.id) {
									if (!_item.children) {
										_item.children = []
									}
									_item.children.push(item)
								}
							})
						}
					})
					this.settlementtasklist = root
					this.settlementtasksource = res
					this.loading = false

				})
			},
			itemClick(node, item, e) {
				this.$emit('select', {
					id: item.id,
					name: item.name,
					parentid:item.parentid,
					childrenid:item.childrenid,
					settlementtasksource:this.settlementtasksource
					
				})
				e.stopPropagation()
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
			timestampToYear(timestamp) {
				let date = new Date(timestamp)
				let year = date.getFullYear()
				return year
			}
		},
		components: {
			VJstree
		}
	}
</script>